module.exports = __webpack_public_path__ + "media/images/steps/png/215-promotion-2-d81d01131f0d27aa27d959ea66ad8cd1.png";